import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEarthEurope } from '@fortawesome/free-solid-svg-icons';
import { faFileLines, faCalendar} from '@fortawesome/free-regular-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FormattedMessage } from 'react-intl';
import { getBaseUrl, hasApiExpander, flattenToAppURL } from '@plone/volto/helpers';
import { TitleView, DescriptionView } from '../';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { SearchWidgetModal } from '../';
import { getHeaderInfo } from '../../actions';
import {
  Anontools,
  LanguageSelector,
  Logo,
  Navigation,
  UniversalLink
} from '@plone/volto/components';
import imgHeader from './img/default_header.jpg';


const Header = ({ pathname, fullPathname }) => {
  const dispatch = useDispatch();
  const [isSticky, setIsSticky] = useState(false);
  const [isClient, setIsClient] = useState(false);

  const headerImage = useSelector((state) => state?.header_info?.header_info?.header_image);
  const headerImageURL = headerImage?.image_field !== 'none' && flattenToAppURL(headerImage?.['@id']);
  const headerImageSrcTeaser = headerImageURL ? `${headerImageURL}/@@images/${headerImage.image_field}/teaser` : null;
  const headerImageSrcLarger = headerImageURL ? `${headerImageURL}/@@images/${headerImage.image_field}/larger` : null;
  const headerImageSrcGreat = headerImageURL ? `${headerImageURL}/@@images/${headerImage.image_field}/great` : null;
  const headerImageSrcHuge = headerImageURL ? `${headerImageURL}/@@images/${headerImage.image_field}/huge` : null;
  const headerImageSrcSlide = headerImageURL ? `${headerImageURL}/@@images/${headerImage.image_field}/slide` : null;

  useEffect(() => {
      if (!hasApiExpander('header_info', getBaseUrl(pathname))) {
        dispatch(getHeaderInfo(getBaseUrl(pathname)));
      }
  }, [dispatch, pathname]);

  useEffect(() => {
    setIsClient(false);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return ( 
    <>
      <header >
        <div className={"portalHeader " + (isSticky ? 'sticky' : '')}>

          {/* Barra superior */}
          <div className="topBar"> 
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faEarthEurope} className='text-primary me-2 fs-5' />
              <LanguageSelector />
            </div>
            {false && (<UniversalLink href="https://citaprevia.gestorn.com/rubi/?idioma=ca_ES&id_oficina_sele=0#nbb" className="topBar__btn"><FontAwesomeIcon className="topBar__btn__icon" icon={faCalendar} /><FormattedMessage id="Cita prèvia" defaultMessage="Cita prèvia" /></UniversalLink>)}
            <UniversalLink href="https://www.seu-e.cat/ca/web/proursa" className="topBar__btn"><FontAwesomeIcon className="topBar__btn__icon" icon={faFileLines} /><FormattedMessage id="Seu electrònica" defaultMessage="Seu electrònica" /></UniversalLink>
          </div>

          {/* Logo */}
          <div className="headerLogo">
            <Logo />
          </div>

          {/* Navegació principal */}
          <Navigation pathname={pathname} />

          {/* Cerca */}
          <SearchWidgetModal  />
        
          {/* WhasApp AMAGAT */}
          {isClient && (
          <UniversalLink className="whatsAppBtn" href={`https://wa.me/?text=${encodeURIComponent(window?.location?.href || '')}`} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faWhatsapp} />
            <span className="visually-hidden">
              <FormattedMessage id="Share in WhatsApp" defaultMessage="Share in WhatsApp" />
            </span>
          </UniversalLink>
          )}

        </div>
        <div className="stickyFixer"></div>

        <div className='head__title'>
          {headerImage?.image_field !== 'none' ? (
              <img src={headerImageSrcSlide} 
                alt="" 
                className='head__title__img'
                srcSet={`${headerImageSrcTeaser} 600w, ${headerImageSrcLarger} 800w, ${headerImageSrcGreat} 1200w, ${headerImageSrcHuge} 1600w, ${headerImageSrcSlide} 1920w`}
                sizes="100vw"
                />
          ) : (
              <img src={imgHeader} alt="" className='head__title__img' />
          )}

          <Breadcrumbs pathname={fullPathname} />

          <TitleView pathname={fullPathname} />
        </div>

        <DescriptionView pathname={fullPathname} />

      </header>
      
    </>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
